import * as L from 'leaflet';

export const baseLayers = {
  Openstreetmap: L.tileLayer(
    'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
  ),
  Sentinel:L.tileLayer('https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg', {
    attribution: '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
    tileSize: 256,
    opacity: 0.7
})
};

export const overlays = {};